<script setup lang="ts">
import { ref, watch } from "vue";

/**
 * A single labelled checkbox wired into vee-validate, drawn with
 * bulma-checkradio the way the phila inputs are. The real <input> stays in the
 * document (bulma-checkradio only makes it transparent), so it is focusable
 * and announced with its label.
 */
const props = withDefaults(
  defineProps<{
    id: string;
    label: string;
    modelValue?: boolean;
    rules?: string;
  }>(),
  {
    modelValue: false,
    rules: "",
  },
);

const emit = defineEmits(["update:modelValue"]);
const checked = ref(props.modelValue);

watch(
  () => props.modelValue,
  (val) => {
    if (val !== checked.value) checked.value = val;
  },
);
watch(checked, (val) => emit("update:modelValue", val));
</script>

<template>
  <Field
    v-slot="{ errorMessage, handleChange }"
    :name="id"
    :rules="rules"
    :model-value="checked"
    type="checkbox"
    :value="true"
    :unchecked-value="false"
  >
    <div
      class="input-wrap input-checkbox"
      :class="{ 'has-error': errorMessage }"
    >
      <input
        :id="id"
        v-model="checked"
        type="checkbox"
        class="is-checkradio"
        :aria-invalid="errorMessage ? 'true' : undefined"
        :aria-describedby="errorMessage ? `${id}-error` : undefined"
        @change="handleChange($event, false)"
      >
      <label :for="id">{{ label }}</label>
      <p
        v-if="errorMessage"
        :id="`${id}-error`"
        class="input-error-msg help is-danger"
      >
        {{ errorMessage }}
      </p>
    </div>
  </Field>
</template>
